import {
    CERTIFICATE_CATEGORY,
    CERTIFICATE_MAILING_ADDRESS,
    LOCAL_ADDRESS,
    OVERSEAS_ADDRESS,
    CERTIFICATE_OWNER_PARTICULARS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/SSOCApplication';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatSSOCApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'ship-station-operator-certificate',
        formID: 'ship-station-operator-certificate',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${CERTIFICATE_CATEGORY}-please-select-the-certification-you-want-to-apply`]:
                licenceDetails?.certificateCategory?.pleaseSelectTheCertificateYouWishToApply ?? '-',

            [`${CERTIFICATE_MAILING_ADDRESS}-collection-method`]: licenceDetails?.certificateMailingAddress?.collectionMethod ?? '-',
            [`${CERTIFICATE_MAILING_ADDRESS}-same-as-billing-address`]:
                licenceDetails?.certificateMailingAddress?.sameAsBillingAddress ?? '-',

            [`${LOCAL_ADDRESS}-building-name`]: licenceDetails?.certificateMailingAddress?.localAddress?.buildingName ?? '-',
            [`${LOCAL_ADDRESS}-postal-code`]: licenceDetails?.certificateMailingAddress?.localAddress?.postalCode ?? '-',
            [`${LOCAL_ADDRESS}-street-name`]: licenceDetails?.certificateMailingAddress?.localAddress?.streetName ?? '-',
            [`${LOCAL_ADDRESS}-block-house-no`]: licenceDetails?.certificateMailingAddress?.localAddress?.blockNo ?? '-',
            [`${LOCAL_ADDRESS}-floor-level`]: licenceDetails?.certificateMailingAddress?.localAddress?.floor ?? '-',
            [`${LOCAL_ADDRESS}-unit`]: licenceDetails?.certificateMailingAddress?.localAddress?.unit ?? '-',

            [`${OVERSEAS_ADDRESS}-foreign-address-line-one`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine1 ?? '-',
            [`${OVERSEAS_ADDRESS}-foreign-address-line-two`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine2 ?? '-',
            [`${OVERSEAS_ADDRESS}-foreign-address-line-three`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine3 ?? '-',
            [`${OVERSEAS_ADDRESS}-city`]: licenceDetails?.certificateMailingAddress?.city ?? '-',
            [`${OVERSEAS_ADDRESS}-state`]: licenceDetails?.certificateMailingAddress?.state ?? '-',
            [`${OVERSEAS_ADDRESS}-zip-code`]: licenceDetails?.certificateMailingAddress?.zipCode ?? '-',
            [`${OVERSEAS_ADDRESS}-country`]: licenceDetails?.certificateMailingAddress?.country ?? '-',

            [`${CERTIFICATE_OWNER_PARTICULARS}-owner-name`]: licenceDetails?.certificateSOwnerParticulars?.ownerName ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-sex`]: licenceDetails?.certificateSOwnerParticulars?.Sex ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-date-of-birth`]:
                formatDateTo_ddMMyyyy(licenceDetails?.certificateSOwnerParticulars?.dateOfBirth) ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-id-type`]: licenceDetails?.certificateSOwnerParticulars?.idTypeIdNumber?.idType ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-nationality`]: licenceDetails?.certificateSOwnerParticulars?.nationality ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-place-of-birth`]: licenceDetails?.certificateSOwnerParticulars?.placeOfBirth ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-height`]: licenceDetails?.certificateSOwnerParticulars?.heightCm ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-colour-of-eyes`]: licenceDetails?.certificateSOwnerParticulars?.colourOfEyes ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-colour-of-hair`]: licenceDetails?.certificateSOwnerParticulars?.colourOfHair ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-complexion`]: licenceDetails?.certificateSOwnerParticulars?.complexion ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-visible-peculiarities`]:
                licenceDetails?.certificateSOwnerParticulars?.visiblePeculiarities ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-medical-certificate-issue-date`]:
                formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.medicalCertificateIssueDate) ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-medical-certificate-expiry-date`]:
                formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.medicalCertificateExpiryDate) ?? '-',
            [`${CERTIFICATE_OWNER_PARTICULARS}-cdc-no`]: licenceDetails?.certificateSOwnerParticulars?.cdcNo ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-ship-station-operator-certificate',
            formID: 'amend-ship-station-operator-certificate',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${CERTIFICATE_CATEGORY}-amend-table`]: [...mapped],
                [`${CERTIFICATE_CATEGORY}-please-select-the-certification-you-want-to-apply`]:
                    licenceDetails?.certificateCategory?.pleaseSelectTheCertificateYouWishToApply ?? '-',

                [`${CERTIFICATE_MAILING_ADDRESS}-collection-method`]: licenceDetails?.certificateMailingAddress?.collectionMethod ?? '-',

                [`${LOCAL_ADDRESS}-building-name`]: licenceDetails?.certificateMailingAddress?.localAddress?.buildingName ?? '-',
                [`${LOCAL_ADDRESS}-postal-code`]: licenceDetails?.certificateMailingAddress?.localAddress?.postalCode ?? '-',
                [`${LOCAL_ADDRESS}-street-name`]: licenceDetails?.certificateMailingAddress?.localAddress?.streetName ?? '-',
                [`${LOCAL_ADDRESS}-block-house-no`]: licenceDetails?.certificateMailingAddress?.localAddress?.blockNo ?? '-',
                [`${LOCAL_ADDRESS}-floor-level`]: licenceDetails?.certificateMailingAddress?.localAddress?.floor ?? '-',
                [`${LOCAL_ADDRESS}-unit`]: licenceDetails?.certificateMailingAddress?.localAddress?.unit ?? '-',

                [`${OVERSEAS_ADDRESS}-foreign-address-line-one`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine1 ?? '-',
                [`${OVERSEAS_ADDRESS}-foreign-address-line-two`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine2 ?? '-',
                [`${OVERSEAS_ADDRESS}-foreign-address-line-three`]: licenceDetails?.certificateMailingAddress?.foreignAddressLine3 ?? '-',
                [`${OVERSEAS_ADDRESS}-city`]: licenceDetails?.certificateMailingAddress?.city ?? '-',
                [`${OVERSEAS_ADDRESS}-state`]: licenceDetails?.certificateMailingAddress?.state ?? '-',
                [`${OVERSEAS_ADDRESS}-zip-code`]: licenceDetails?.certificateMailingAddress?.zipCode ?? '-',
                [`${OVERSEAS_ADDRESS}-country`]: licenceDetails?.certificateMailingAddress?.country ?? '-',

                [`${CERTIFICATE_OWNER_PARTICULARS}-owner-name`]: licenceDetails?.certificateSOwnerParticulars?.ownerName ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-sex`]: licenceDetails?.certificateSOwnerParticulars?.Sex ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-date-of-birth`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.certificateSOwnerParticulars?.dateOfBirth) ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-id-type`]: licenceDetails?.certificateSOwnerParticulars?.idTypeIdNumber?.idType ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-nationality`]: licenceDetails?.certificateSOwnerParticulars?.nationality ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-place-of-birth`]: licenceDetails?.certificateSOwnerParticulars?.placeOfBirth ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-height`]: licenceDetails?.certificateSOwnerParticulars?.heightCm ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-colour-of-eyes`]: licenceDetails?.certificateSOwnerParticulars?.colourOfEyes ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-colour-of-hair`]: licenceDetails?.certificateSOwnerParticulars?.colourOfHair ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-complexion`]: licenceDetails?.certificateSOwnerParticulars?.complexion ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-visible-peculiarities`]:
                    licenceDetails?.certificateSOwnerParticulars?.visiblePeculiarities ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-medical-certificate-issue-date`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.medicalCertificateIssueDate) ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-medical-certificate-expiry-date`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.certificateInformation?.medicalCertificateExpiryDate) ?? '-',
                [`${CERTIFICATE_OWNER_PARTICULARS}-details-of-dispensations`]: licenceDetails?.certificateSOwnerParticulars?.cdcNo ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const ssocPayloadApplication = {
    formatSSOCApplication
};

export default ssocPayloadApplication;
